<template>
  <div
    id="import-subscriptions"
  >

    <div
      class="alert alert-info text-center"
      v-if="importedTags.length"
    >
      <p>
        Imported Subscription Tags
      </p>

      <div>
        <router-link
          v-for="tag in importedTags"
          :key="tag.id"
          class="btn btn-primary btn-sm ml-1"
          :to="{
            name: 'tag',
            params: {
              tagId: tag.id
            }
          }"
        >
          {{ tag.attributes.name }}
        </router-link>
      </div>
    </div>

    <subscription-nav />

    <h2>Import Subscriptions</h2>

    <form
      method="post"
      :action="subscriptionImportUrl"
      v-on:submit.prevent="importSubscriptions"
    >
      <div>
        <h3>
          Import Subscriptions
        </h3>

        <div
          class="form-group"
          >
          <div
            class="custom-file"
          >
            <label
              class="custom-file-label required"
              for="import-users"
            >
              Import Subscriptions by CSV
            </label>
            <input
              type="file"
              name="subscriptions[file]"
              id="import-publishers"
              class="custom-file-input"
              ref="import_file"
              v-on:change="onFileChange"
              required
            />
          </div>
          <div
            v-if="importFileName"
          >
            {{ importFileName }}
          </div>
        </div>

        <div
          class="form-group"
        >
          <label
            for="subscription_format_type"
          >
            Subscription Format Type
          </label>

          <select
            id="subscription_format_type"
            name="subscriptions[file_format_type]"
            class="form-control"
          >
            <option
              value="kickstarter"
            >
              Kickstarter Backers
            </option>
          </select>
        </div>
      </div>

      <div class="form-group row">
        <div class="col">
          <label for="purchase-purchasable-item-search">
            Purchasable Item/Subscription
          </label>

          <input
            type="text"
            name="purchasable-item-search"
            placeholder="Search for Items"
            class="form-control"
            v-model="query"
            v-on:keyup="searchPurchasableItems"
            required
          />
        </div>
      </div>

      <div class="form-group row" v-if="searchResults && searchResults.length">
        <div class="col-4">
          <label for="found-purchasable-items">
            Attach Specific Purchasable Item/Subscription To Each Record
          </label>

          <p>
            This is for importing files that contain
            no specific purchasable item records.
          </p>
        </div>
        <div class="col-7">
          <select
            class="form-control"
            id="found-purchasable-items"
            name="subscriptions[purchasable_item_id]"
          >
            <option
              v-for="result in searchResults"
               v-bind:value="result.id"
               :data-price="result.price"
               :data-subscription="result.subscription"
            >
              {{ result.name }}
            </option>
          </select>
        </div>
      </div>
      <div v-else-if="query">
        <p class="alert alert-warning" role="alert">
          No items found.
        </p>
      </div>

      <div class="form-group">
        <label for="found-purchasable-items">
          Attach Tags To Each Record
        </label>

        <p>
          This allows for easier grouping of subscriptions and purchases.
        </p>

        <tag-select
          type="subscriptions[tag_ids][]"
          :selectedTags="tagSlugs"
          noButtons
        />
      </div>

      <div
        class="form-group"
      >
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            name="subscriptions[suppress_repeat_subs]"
            id="subscriptions_suppress_repeat_subs"
            checked
          >

          <label
            for="subscriptions_suppress_repeat_subs"
            class="form-check-label"
          >
            Suppress Repeat Subscriptions
          </label>
        </div>
    </div>

    <p
      class="alert alert-info text-center"
    >
      This will import all records as a purchase,

      but will not create new subscriptions if the email has a pre-existing subscription record.
    </p>

    <button
      class="btn btn-primary btn-block"
    >
      Import Subscription
      <spinner size="small" v-if="loading"></spinner>
    </button>

    <button
      class="btn btn-danger btn-block"
      v-on:click.prevent="confirmDestroy"
    >
      Re-import?
      <input
        v-model="destroy"
        type="hidden"
        name="subscriptions[destroy]"
      />

      <spinner size="small" v-if="loading"></spinner>
    </button>
    </form>

  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner'

import PurchasableItemSearch from '@/components/PurchasableItemSearch'
import SubscriptionNav from '@/components/SubscriptionNav'
import TagSelect from '@/components/TagSelect'

import TagMixin from '@/mixins/TagMixin'

import FlashStore from '@/stores/FlashStore'

export default {
  data () {
    return {
      destroy: false,
      importFileName: undefined,
      importedTags: [],
      loading: false,
      purchasable_items: [],
      query: undefined,
      searchResults: [],
      selectedTags: [],
      tags: []
    }
  },

  components: {
    'purchasable-item-search': PurchasableItemSearch,
    'spinner': Spinner,
    'subscription-nav': SubscriptionNav,
    'tag-select': TagSelect
  },

  computed: {
    subscriptionImportUrl () {
      return this.apiUrl('/admin/import_subscriptions')
    }
  },

  mixins: [
    TagMixin
  ],

  methods: {
    onFileChange () {
      const files = this.$refs.import_file.files
      this.importFileName = undefined

      if (files.length) {
        this.importFileName = files[0].name
      }
    },

    importSubscriptions (ev) {
      this.loading = true
      this.importedTags = []

      this.bindSubmit(ev).then((resp) => {
        this.loading = false
        let data = resp.body
        this.importedTags = data.tags

        FlashStore.result(
          resp.body.subscriptions_count + ' Subscriptions imported.'
        )
      }, (resp) => {
        this.loading = false
        this.$parent.processErrors(resp)
      })
    },

    addPurchasableItem () {
      const select = document.getElementById('found-purchasable-items')
      const option = select.options[select.selectedIndex]

      if (this.canChangePurchasableItem(option)) {
        const item = {
          name: option.text,
          id: option.value,
          price: option.dataset.price
        }

        this.gross = (parseFloat(this.gross) || 0) + parseFloat(item.price)

        this.purchasable_items.push(item)
      }
    },

    canChangePurchasableItem (option) {
      if (option.dataset.subscription && this.status === 'completed') {
        alert('Subscriptions cannot be added to a purchase while the purchase status is set to \'complete\'.')

        return false
      }

      return true
    },

    confirmDestroy (ev) {
      if (confirm(
        'This will destroy all subscription records with selected tags, replacing them with the uploaded records. This cannot be undone. Do you want to continue?'
      )) {
        if (confirm('Are you absolutely positive?')) {
          this.destroy = true
          // this.importSubscriptions(ev)
        }
      }
    },

    removePurchasableItem (ev) {
      const id = ev.target.value

      if (
        !ev.target.checked &&
        confirm('Are you sure you want to remove this item from the purchase?')
      ) {
        this.purchasable_items = this.purchasable_items.filter((item) => {
          return item.id !== id
        })
      } else if (!ev.target.checked) {
        ev.target.checked = true
      }
    },

    searchPurchasableItems () {
      this.$http.post(this.apiUrl('/purchasable_items/search', true), {
        query: this.query,
        page: {
          order_by: 'name',
          size: 50
        }
      }).then((resp) => {
        let results = this.processSuccess(resp)
        this.searchResults = results
      }, this.processErrors)
    }
  },

  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ImportSubscriptions.vue